import {postJson} from './http'
const baseUrl = '/api/admin/kmc/govparks'

// 获取内容列表
export const getAllGovparkcontent = v => postJson(`${baseUrl}/getAllGovparkcontent`, v.data, v.success, v.error)
// 获取园区列表
export const getAllGovparksinfo = v => postJson(`${baseUrl}/getAllGovparksinfo`, v.data, v.success, v.error)
// 获取内容详情
export const getGovparkcontentinfo = v => postJson(`${baseUrl}/getGovparkcontentinfo`, v.data, v.success, v.error)
// 获取园区详情
export const getGovparksinfo = v => postJson(`${baseUrl}/getGovparksinfo`, v.data, v.success, v.error)
// 删除内容（支持批量删除）
export const uploadGovparkcontentStatus = v => postJson(`${baseUrl}/uploadGovparkcontentStatus`, v.data, v.success, v.error)
// 保存内容信息
export const uploadGovparkcontentinfo = v => postJson(`${baseUrl}/uploadGovparkcontentinfo`, v.data, v.success, v.error)
// 删除园区（支持批量删除）
export const uploadGovparksStatus = v => postJson(`${baseUrl}/uploadGovparksStatus`, v.data, v.success, v.error)
// 保存园区信息
export const uploadGovparksinfo = v => postJson(`${baseUrl}/uploadGovparksinfo`, v.data, v.success, v.error)
// 改变园区推荐状态 uploadGovparksIsrecommend
export const uploadGovparksIsrecommend = v => postJson(`${baseUrl}/uploadGovparksIsrecommend`, v.data, v.success, v.error)